<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2qSmSS/tc-custom/9781480470590.jpg?1733113338972" alt="This image is the cover for the book Ariana"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Ariana
      </h1>
      <p class="bookDescription body article font2">
        <b>The rarefied realm of opera comes alive in the story of a diva torn between passion and ambition</b><br/>She is Kavalaris—the most magnificent singer ever to grace the international operatic stage. Her talent is the stuff of legend and has made the men around her rich. Mark Rutherford first saw her when he was a young boy—and he cannot forget her. It will be almost two decades—separated by a depression and a world war—before they meet again and fall deeply in love.<br/>Beginning in 1928 and continuing for almost six decades, <i>Ariana </i>tells the story of a performer whose extraordinary gift touches everyone who hears her. But who is the woman behind the phenomenon? As Ariana bestows her gift on other singers, she ensures her immortality. It will come at a great cost to her own life. Because ambition—and the kind of success most people only dream of—always exacts a price.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edward Stewart
      </h2>
      
      <p class="authorDescription body article">Edward Stewart (1938&shy;&ndash;1996) grew up in New York City and Cuba. He was educated at Phillips Exeter Academy and at Harvard, where he edited the famed <i>Lampoon </i>humor magazine. He studied music in Paris with Nadia Boulanger, and worked as a composer and arranger before launching his career as a writer. His first novel, <i>Orpheus on Top</i>, was published in 1966. He wrote thirteen more novels, including the bestselling Vince Cardozo thrillers <i>Privileged Lives</i>, <i>Jury Double</i>, <i>Mortal Grace</i>, and <i>Deadly Rich</i>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7b3e0c11